import { Button } from 'rebass';
import { styles } from './homeStyles';

const DayNightToggle = ({ night, setNight }) => (
  <Button
    variant="outline"
    sx={styles.toggleButton(night)}
    aria-label={night ? 'Switch to day mode' : 'Switch to night mode'}
    onClick={() => setNight(n => !n)}
  >
    <span style={{ display: 'inline-block', verticalAlign: 'middle', lineHeight: '1.2' }}>
      {night ? '🌙 Night' : '☀️ Day'}
    </span>
  </Button>
);

export default DayNightToggle;
